import React, { useEffect, useState } from "react";
import doc3Service from "../../services/doc3.service";

const CountSend = (props: { scheId: number; curriId: number }) => {
  const { scheId, curriId } = props;
  const [countSend, setCountSend] = useState(0);

  useEffect(() => {
    (async () => {
      await doc3Service.countSend(curriId, scheId).then((res) => {
        // setCountSend(res.data)
        setCountSend(res.data.length);
      });
    })();
  }, []);
  return <>{countSend}</>;
};

export default CountSend;
